
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      filters: {
        displayWithout: true,
        displayWith: true,
        categorizedView: true,
        isImageView: false
      },
      selectedFilter: "all"
    };
  },
  created() {
    this.$nuxt.$on("reapply-filter", () => {
      this.updateFilterChanges();
    });
  },
  watch: {
    menuUploadGridFilters: {
      handler(val) {
        this.filters = { ...val };
        if (this.filters.displayWith && this.filters.displayWithout) {
          this.selectedFilter = "all";
        } else if (this.filters.displayWith) {
          this.selectedFilter = "displayWith";
        } else if (this.filters.displayWithout) {
          this.selectedFilter = "displayWithout";
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState("menu", ["menuUploadGridFilters"]),
    displayItems() {
      return [
        { name: "All Items", value: "all" },
        { name: `Without ${this.getName}`, value: "displayWithout" },
        { name: `With ${this.getName}`, value: "displayWith" }
      ];
    },
    getName() {
      switch (this.id) {
        case "add-photos":
          return "Images";
        case "set-addons":
          return "Add-ons";
        case "add-description":
          return "Description";
        case "set-choices":
          return "Choices";
        default:
          return "";
      }
    }
  },
  methods: {
    ...mapActions("menu", ["updateMenuUploadGridFilters"]),
    handleFilterChange() {
      switch (this.selectedFilter) {
        case "all":
          this.filters.displayWithout = true;
          this.filters.displayWith = true;

          break;

        case "displayWithout":
          this.filters.displayWithout = true;
          this.filters.displayWith = false;
          break;

        case "displayWith":
          this.filters.displayWithout = false;
          this.filters.displayWith = true;
          break;
      }

      this.updateFilterChanges();
    },
    updateFilterChanges() {
      this.updateMenuUploadGridFilters(this.filters);
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("reapply-filter");
  }
};
